module.exports = __webpack_public_path__ + "static/media/banner.c2bdae5c.png";